export default __webpack_public_path__ + "static/media/nmp1.f1702cd2.png";